import * as Holistic from '@mediapipe/holistic';

export function validate(results: Holistic.Results): { valid: boolean, messageKey: string } {
    if (!results.poseLandmarks || !results.faceLandmarks) {
        return { valid: false, messageKey: 'sign_feedback.direct_record.positioning.no_pose_or_face' };
    }

    // NOTE: Temporarily disable elbow visibility gating. Keep for potential re-enable.
    // const leftElbow = results.poseLandmarks[Holistic.POSE_LANDMARKS.LEFT_ELBOW];
    // const rightElbow = results.poseLandmarks[Holistic.POSE_LANDMARKS.RIGHT_ELBOW];
    // if (!leftElbow || !rightElbow || (leftElbow.visibility ?? 0) < 0.3 || (rightElbow.visibility ?? 0) < 0.3) {
    //     return { valid: false, messageKey: 'sign_feedback.direct_record.positioning.elbows_not_visible' };
    // }

    // FaceMesh landmarks do not expose visibility. Treat face as visible if we have
    // a valid, normalized position for the nose landmark.
    const nose = results.faceLandmarks[0] as any;
    const hasValidNose = nose && Number.isFinite(nose.x) && Number.isFinite(nose.y)
        && nose.x >= 0 && nose.x <= 1 && nose.y >= 0 && nose.y <= 1;
    if (!hasValidNose) {
        return { valid: false, messageKey: 'sign_feedback.direct_record.positioning.face_not_visible' };
    }

    const leftHip = results.poseLandmarks[Holistic.POSE_LANDMARKS.LEFT_HIP];
    const rightHip = results.poseLandmarks[Holistic.POSE_LANDMARKS.RIGHT_HIP];
    if (!leftHip || !rightHip || (leftHip.visibility ?? 0) < 0.3 || (rightHip.visibility ?? 0) < 0.3) {
        return { valid: false, messageKey: 'sign_feedback.direct_record.positioning.belly_not_visible' };
    }

    return { valid: true, messageKey: 'sign_feedback.direct_record.positioning.perfect' };
}


